import mediumLogo from "../../images/medium-logo.svg";
import devtoLogo from "../../images/devto-logo.svg";

export const PublicationType = Object.freeze({
  MEDIUM: { name: "Medium", color: "#1a1a1a", logo: mediumLogo },
  DEVTO:  { name: "dev.to",  color: "#0a0a0a", logo: devtoLogo },
});

export const projects = [
  {
    name: "lucky-movie",
    language: "Python",
    stars: 0,
    description: "AI-powered movie recommendation engine. Search a film, tune your mood with emotion sliders, and discover similar movies using Faiss, HuggingFace embeddings, and emotional profiling.",
    repo: "https://github.com/toothlesspanda/movies-recommender",
    site: "https://luckymovie.link",
    image: "/projects/lucky-movie.gif",
  },
  {
    name: "eng-ladder-tool",
    language: "JavaScript",
    stars: 3,
    description: "Browser-based tool for engineering managers to track direct reports' career progression against customizable role frameworks, with radar charts.",
    repo: "https://github.com/toothlesspanda/eng-ladder-tool",
    image: "/projects/eng-ladder-tool.png",
  },
  {
    name: "earthquake-app",
    language: "Ruby",
    stars: 1,
    description: "Rails app for visualizing USGS earthquake data with user authentication, a REST API with filtering, and 3D seismic visualizations with Three.js.",
    repo: "https://github.com/toothlesspanda/earthquake-app",
    image: "/projects/earthquake-app.gif",
  },
  {
    name: "ardc-website",
    language: "JavaScript",
    stars: 0,
    description: "Website for As Raparigas do Codigo, built with React and Apex API integration. Contributed across all pages, restructured the project, and built the forms and APIs.",
    repo: "https://github.com/As-Raparigas-do-Codigo/ardc-website",
    site: "https://www.raparigasdocodigo.pt/",
    image: "/projects/ardc.gif",
  },
  {
    name: "community-where",
    language: "Ruby",
    stars: 2,
    description: "Open-source Rails app that lets people map useful community resources in their neighborhoods (recycling bins, EV chargers) with community validation.",
    repo: "https://github.com/toothlesspanda/community-where",
  },
  {
    name: "emoji-totext",
    language: "JavaScript",
    stars: 0,
    description: 'npm package that converts emojis to their text descriptions — e.g. a pizza slice becomes "a slice of pizza".',
    repo: "https://github.com/toothlesspanda/emoji-totext",
  },
  {
    name: "cassia-assistant",
    language: "Python",
    stars: 0,
    description: "Home Assistant setup running on a Raspberry Pi 4 with Docker, with modular sensor scripts for custom smart home configurations.",
    repo: "https://github.com/toothlesspanda/cassia-assistant",
  },
  {
    name: "adventofcode",
    language: "JavaScript",
    stars: 0,
    description: "My Advent of Code solutions.",
    repo: "https://github.com/toothlesspanda/adventofcode",
  },
];

export const langColor = {
  JavaScript: "#e8c96a",
  Ruby:       "#cc342d",
  Python:     "#3572A5",
};

export const publications = [
  {
    title: "Acessibilidade web: apenas 13% das paginas da administracao publica estao conforme a lei",
    year: "2018", venue: "Gerador",
    href: "https://gerador.eu/acessibilidade-web-apenas-13-das-paginas-da-administracao-publica-estao-conforme-a-lei/",
  },
  {
    title: "Semantic Content Analysis Supporting Web Accessibility Evaluation",
    year: "2018", venue: "15th International Web for All Conference",
    href: "https://repositorio.ul.pt/handle/10451/30934",
  },
  {
    title: "SCREW — Semantic Content Analysis for Repair and Evaluation of Web Accessibility",
    year: "2017", venue: "MSc Thesis · 18/20",
    description: "AI-based algorithm (Clarifai, Swoogle, Indico.io) to measure semantic similarity between alt texts and images, integrated into QualWeb.",
    href: "https://repositorio.ul.pt/handle/10451/30934",
  },
  {
    title: "Development Technologies Impact in Web Accessibility",
    year: "2016", venue: "13th International Web for All Conference",
    href: "https://repositorio.ul.pt/handle/10451/30934",
  },
];

export const menuItems = [
  { id: "about",    label: "about" },
  { id: "projects", label: "projects" },
  { id: "articles", label: "articles" },
  { id: "cv",       label: "cv" },
];

export const RADIUS = 200;
export const HUB = 580;

/* ── Sprite data ── */
const _ = null;
const H = '#3a2a18', C = '#4a3820', S = '#f0c8a0', L = '#88b8d8', G = '#787878';
const T = '#e8e4dc', P = '#7a9ab8', O = '#e8d070', W = '#e8e0d0';
const K = '#1a1a1a', E = '#604020';

export const runSprite = [
  [_,_,_,_,_,C,H,C,H,C,H,C,H,_,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,C,H,C,H,C,H,C,H,C,H,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,C,H,H,H,H,H,H,H,H,H,H,C,_,_,_,_,_,_,_,_,_],
  [_,_,C,H,C,H,H,H,H,H,H,H,H,C,H,C,_,_,_,_,_,_,_,_],
  [_,_,H,C,H,H,H,H,H,H,H,H,H,H,H,C,H,_,_,_,_,_,_,_],
  [_,_,C,H,H,H,H,H,H,H,H,H,H,H,H,H,C,_,_,_,_,_,_,_],
  [_,_,H,C,H,H,H,H,H,S,S,S,S,S,S,H,C,_,_,_,_,_,_,_],
  [_,_,C,H,C,H,H,H,S,S,S,S,S,S,S,H,H,_,_,_,_,_,_,_],
  [_,_,H,C,S,G,G,G,S,S,S,G,G,G,S,C,H,_,_,_,_,_,_,_],
  [_,_,_,C,G,L,L,L,G,G,G,L,L,L,G,C,_,_,_,_,_,_,_,_],
  [_,_,H,C,G,L,L,L,G,S,G,L,L,L,G,C,H,_,_,_,_,_,_,_],
  [_,_,C,H,S,G,G,G,S,S,S,G,G,G,S,H,C,_,_,_,_,_,_,_],
  [_,_,H,C,C,S,S,S,S,S,S,S,S,S,C,H,C,_,_,_,_,_,_,_],
  [_,_,C,H,C,_,S,S,S,S,S,S,S,_,C,H,_,_,_,_,_,_,_,_],
  [_,_,_,H,C,_,T,T,T,T,T,T,T,_,C,H,_,_,_,_,_,_,_,_],
  [_,_,_,C,H,S,T,T,T,T,T,T,T,S,H,C,_,_,_,_,_,_,_,_],
  [_,_,_,H,C,S,T,T,T,T,T,T,T,S,C,H,_,_,_,_,_,_,_,_],
  [_,_,_,C,_,S,_,T,T,T,T,T,_,S,_,C,_,_,_,_,_,_,_,_],
  [_,_,_,H,_,S,_,P,P,P,P,P,_,S,_,H,_,_,_,_,_,_,_,_],
  [_,_,_,C,_,_,_,P,P,P,P,P,_,_,_,C,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,P,P,_,P,P,_,_,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,P,P,P,_,_,_,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,O,W,_,O,W,_,_,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,O,O,O,_,O,O,O,_,_,_,_,_,_,_,_,_,_,_],
];

export const dogSprite = [
  [_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,_,K,K,K,K,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,K,K,K,K,K,K,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,K,K,K,K,K,K,K,K,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,K,K,K,E,K,K,E,K,K,K,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,K,K,K,K,K,K,K,K,K,K,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,K,K,_,K,K,K,K,_,K,K,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,_,K,W,W,K,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,_,K,K,K,K,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,_,K,K,K,K,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,K,K,W,W,K,K,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,K,K,W,W,K,K,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,K,K,K,K,K,K,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,W,K,K,K,K,K,K,W,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,K,K,_,_,K,K,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,K,K,_,_,K,K,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,W,W,_,_,W,W,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_],
];

export const jumpSprite = [
  [_,_,_,_,_,C,H,C,H,C,H,C,H,_,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,C,H,C,H,C,H,C,H,C,H,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,C,H,H,H,H,H,H,H,H,H,H,C,_,_,_,_,_,_,_,_,_],
  [_,_,C,H,C,H,H,H,H,H,H,H,H,C,H,C,_,_,_,_,_,_,_,_],
  [_,_,H,C,H,H,H,H,H,H,H,H,H,H,H,C,H,_,_,_,_,_,_,_],
  [_,_,C,H,H,H,H,H,H,H,H,H,H,H,H,H,C,_,_,_,_,_,_,_],
  [_,_,H,C,H,H,H,H,H,S,S,S,S,S,S,H,C,_,_,_,_,_,_,_],
  [_,_,C,H,C,H,H,H,S,S,S,S,S,S,S,H,H,_,_,_,_,_,_,_],
  [_,_,H,C,S,G,G,G,S,S,S,G,G,G,S,C,H,_,_,_,_,_,_,_],
  [_,_,_,C,G,L,L,L,G,G,G,L,L,L,G,C,_,_,_,_,_,_,_,_],
  [_,_,H,C,G,L,L,L,G,S,G,L,L,L,G,C,H,_,_,_,_,_,_,_],
  [_,_,C,H,S,G,G,G,S,S,S,G,G,G,S,H,C,_,_,_,_,_,_,_],
  [_,_,H,C,C,S,S,S,S,S,S,S,S,S,C,H,C,_,_,_,_,_,_,_],
  [_,S,C,H,C,_,S,S,S,S,S,S,S,_,C,H,_,S,_,_,_,_,_,_],
  [S,_,_,H,C,_,T,T,T,T,T,T,T,_,C,H,_,_,S,_,_,_,_,_],
  [_,S,_,C,H,_,T,T,T,T,T,T,T,_,H,C,_,S,_,_,_,_,_,_],
  [_,_,_,H,C,_,T,T,T,T,T,T,T,_,C,H,_,_,_,_,_,_,_,_],
  [_,_,_,C,_,_,_,T,T,T,T,T,_,_,_,C,_,_,_,_,_,_,_,_],
  [_,_,_,H,_,_,_,P,P,P,P,P,_,_,_,H,_,_,_,_,_,_,_,_],
  [_,_,_,C,_,_,_,P,P,P,P,P,_,_,_,C,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,P,P,P,P,P,_,_,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,O,W,O,_,O,W,O,_,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_],
];

const D = '#8b6530', d = '#a07840', R = '#cc3030', U = '#2a3a70', N = '#303030', M = '#909090', F = '#7a1a28', f = '#a83040';

export const bugSprite = [
  [_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,F,_,_,_,_,_,_,F,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,F,_,_,_,_,F,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,F,F,F,F,_,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,F,F,W,F,W,F,F,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,F,f,f,f,F,f,f,f,F,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,F,_,F,f,R,F,f,F,R,f,F,_,F,_,_,_,_,_,_],
  [_,_,_,_,F,_,_,F,f,f,f,f,f,f,f,F,_,_,F,_,_,_,_,_],
  [_,_,_,_,_,F,_,F,f,R,F,f,F,R,f,F,_,F,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,F,f,f,F,f,f,F,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,F,F,F,F,F,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_],
];

export const bossSprite = [
  [_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,_,N,N,N,N,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,N,N,N,N,N,N,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,S,S,S,S,S,S,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,N,S,N,N,S,N,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,S,N,S,S,N,S,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,S,S,S,S,S,S,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,S,R,R,R,R,S,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,_,S,S,S,S,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,_,_,S,S,_,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,U,U,U,U,U,U,U,U,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,U,U,U,R,R,U,U,U,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,U,U,U,R,R,U,U,U,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,U,U,U,U,U,U,U,U,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,S,U,U,U,U,U,U,S,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,U,U,_,_,U,U,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,U,U,_,_,U,U,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,U,U,_,_,U,U,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,U,U,_,_,U,U,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,N,N,_,_,N,N,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_],
];

export const deadlineSprite = [
  [_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,N,_,_,_,_,N,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,N,_,_,_,_,N,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,R,R,R,R,R,R,R,R,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,R,R,R,R,R,R,R,R,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,W,W,W,W,W,W,W,W,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,W,W,W,W,W,W,W,W,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,W,R,R,W,R,R,R,W,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,W,W,R,W,R,W,R,W,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,W,R,R,W,R,W,R,W,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,W,W,R,W,R,W,R,W,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,W,R,R,W,R,R,R,W,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,W,W,W,W,W,W,W,W,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_],
];

export const sadSprite = [
  [_,_,_,_,_,C,H,C,H,C,H,C,H,_,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,C,H,C,H,C,H,C,H,C,H,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,C,H,H,H,H,H,H,H,H,H,H,C,_,_,_,_,_,_,_,_,_],
  [_,_,C,H,C,H,H,H,H,H,H,H,H,C,H,C,_,_,_,_,_,_,_,_],
  [_,_,H,C,H,H,H,H,H,H,H,H,H,H,H,C,H,_,_,_,_,_,_,_],
  [_,_,C,H,H,H,H,H,H,H,H,H,H,H,H,H,C,_,_,_,_,_,_,_],
  [_,_,H,C,H,H,H,H,H,S,S,S,S,S,S,H,C,_,_,_,_,_,_,_],
  [_,_,C,H,C,H,H,H,S,S,S,S,S,S,S,H,H,_,_,_,_,_,_,_],
  [_,_,H,C,S,G,G,G,S,S,S,G,G,G,S,C,H,_,_,_,_,_,_,_],
  [_,_,_,C,G,L,L,L,G,G,G,L,L,L,G,C,_,_,_,_,_,_,_,_],
  [_,_,H,C,G,L,L,L,G,S,G,L,L,L,G,C,H,_,_,_,_,_,_,_],
  [_,_,C,H,S,G,G,G,S,S,S,G,G,G,S,H,C,_,_,_,_,_,_,_],
  [_,_,H,C,C,S,S,S,S,S,S,S,L,S,C,H,C,_,_,_,_,_,_,_],
  [_,_,C,H,C,_,S,S,S,S,S,S,S,L,C,H,_,_,_,_,_,_,_,_],
  [_,_,_,H,C,_,T,T,T,T,T,T,T,L,C,H,_,_,_,_,_,_,_,_],
  [_,_,_,C,H,S,T,T,T,T,T,T,T,L,H,C,_,_,_,_,_,_,_,_],
  [_,_,_,H,C,S,T,T,T,T,T,T,T,S,C,H,_,_,_,_,_,_,_,_],
  [_,_,_,C,_,S,_,T,T,T,T,T,_,S,_,C,_,_,_,_,_,_,_,_],
  [_,_,_,H,_,S,_,P,P,P,P,P,_,S,_,H,_,_,_,_,_,_,_,_],
  [_,_,_,C,_,_,_,P,P,P,P,P,_,_,_,C,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,P,P,_,P,P,_,_,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,P,P,P,_,_,_,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,O,W,_,O,W,_,_,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,O,O,O,_,O,O,O,_,_,_,_,_,_,_,_,_,_,_],
];

export const sadDogSprite = [
  [_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,_,K,K,K,K,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,K,K,K,K,K,K,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,K,K,K,K,K,K,K,K,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,K,K,K,E,K,K,E,K,K,K,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,K,K,K,L,K,K,K,K,K,K,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,K,K,_,L,K,K,K,_,K,K,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,_,L,W,W,K,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,_,K,K,K,K,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,_,K,K,K,K,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,K,K,W,W,K,K,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,K,K,W,W,K,K,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,K,K,K,K,K,K,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,W,K,K,K,K,K,K,W,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,K,K,_,_,K,K,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,K,K,_,_,K,K,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,W,W,_,_,W,W,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_],
];

export const celebrateSprite = [
  [_,_,_,_,_,C,H,C,H,C,H,C,H,_,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,C,H,C,H,C,H,C,H,C,H,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,C,H,H,H,H,H,H,H,H,H,H,C,_,_,_,_,_,_,_,_,_],
  [_,_,C,H,C,H,H,H,H,H,H,H,H,C,H,C,_,_,_,_,_,_,_,_],
  [_,_,H,C,H,H,H,H,H,H,H,H,H,H,H,C,H,_,_,_,_,_,_,_],
  [_,_,C,H,H,H,H,H,H,H,H,H,H,H,H,H,C,_,_,_,_,_,_,_],
  [_,_,H,C,H,H,H,H,H,S,S,S,S,S,S,H,C,_,_,_,_,_,_,_],
  [_,_,C,H,C,H,H,H,S,S,S,S,S,S,S,H,H,_,_,_,_,_,_,_],
  [_,_,H,C,S,G,G,G,S,S,S,G,G,G,S,C,H,_,_,_,_,_,_,_],
  [_,_,_,C,G,L,L,L,G,G,G,L,L,L,G,C,_,_,_,_,_,_,_,_],
  [S,_,H,C,G,L,L,L,G,S,G,L,L,L,G,C,H,_,S,_,_,_,_,_],
  [_,S,C,H,S,G,G,G,S,S,S,G,G,G,S,H,C,S,_,_,_,_,_,_],
  [_,S,H,C,C,S,S,S,S,S,S,S,S,S,C,H,C,S,_,_,_,_,_,_],
  [_,_,S,H,C,_,S,S,S,S,S,S,S,_,C,H,S,_,_,_,_,_,_,_],
  [_,_,S,H,C,_,T,T,T,T,T,T,T,_,C,H,S,_,_,_,_,_,_,_],
  [_,_,_,C,H,_,T,T,T,T,T,T,T,_,H,C,_,_,_,_,_,_,_,_],
  [_,_,_,H,C,_,T,T,T,T,T,T,T,_,C,H,_,_,_,_,_,_,_,_],
  [_,_,_,C,_,_,_,T,T,T,T,T,_,_,_,C,_,_,_,_,_,_,_,_],
  [_,_,_,H,_,_,_,P,P,P,P,P,_,_,_,H,_,_,_,_,_,_,_,_],
  [_,_,_,C,_,_,_,P,P,P,P,P,_,_,_,C,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,P,P,P,P,P,_,_,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,O,W,O,_,O,W,O,_,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_],
  [_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_,_],
];

export const DOG_DX = 10;
export const DOG_DY = 2;
export const COMBO_W = 32;

export const pixels = [
  { top: '8%',  left: '10%' },
  { top: '20%', left: '85%' },
  { top: '72%', left: '12%' },
  { top: '82%', left: '78%' },
  { top: '14%', left: '55%' },
  { top: '65%', left: '92%' },
  { top: '40%', left: '4%' },
  { top: '88%', left: '42%' },
];
